module.exports = __webpack_public_path__ + "static/img/218_TO8_1939.966b33f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/218_TO8_1939.jpg
// module id = ktnb
// module chunks = 0